// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__1Ie7T","errorLogs":"EditorFooter_errorLogs__3kboY"};